export interface InventoryTradeBalance {
  selectedItemsSum: number;
  selectedShopItemsSum: number;
  tradeBalance: number;
}
